import notification from 'ant-design-vue/lib/notification'
import moment from 'moment'
import {
  getBiddingRegion,
  getCategoryOption,
  getDictionaryOption,
  getExhibitionStatus,
  getIndustryOption,
  getIsInChina,
  getRegionOption,
} from '@/api/base'

const isObject = (value) => Object.prototype.toString.call(value) === '[object Object]'

export const state = () => {
  return {
    // 地区组件数据
    regionOption: [],
    domesticRegionOption: [],
    biddingRegion: [],
    phoneAreaOption: [],
    // 行业数据
    exhibitionCascaderOption: [],
    exhibitionOneOption: [],
    exhibitionTwoOption: [],
    newsOption: [],
    meetingOption: [],
    moxingOption: [],
    checkboxMoxingOption: [],
    companyOption: [],
    cloudDateOption: [],
    addByYourselfOption: [],
    liveOption: [],
    posterOption: [],
    productOption: [],
    biddingOption: [],
    // 场景
    sceneOption: [],
    // 货币类型
    capitalUnitOption: [],
    // 分类基础数据
    categorySrprovider: [],
    categoryMoxing: [],
    categoryNews: [],
    categoryDesigner: [],
    categoryThirddCompany: [],
    categoryThirdd: [],
    checkboxCategorySrprovider: [],
    checkboxCategoryDesigner: [],
    // 字典基础数据
    kkfxDictionary: [],
    mjdxDictionary: [],
    deliveryDictionary: [],
    exchangedDictionary: [],
    biddingDictionary: [],
    currencyDictionary: [],
    presaleDictionary: [],
    // 过去和未来的五年数据
    pastFutureFiveYears: [],
    // 是否为测试环境
    isTestEnv: process.env.API_HOST,
    // 用户地址相关id
    localContent: {},
    // 用户的地址详细信息, 从洲到市
    regionSelect: [],
    exhibitionStatus: [],

    isInChina: {
      isChina: -1,
    },
  }
}
export const mutations = {
  setRegionOption(state, data) {
    state.regionOption = data
  },

  update(state, payload) {
    Object.keys(payload).forEach((k) => {
      if (isObject(payload[k])) {
        if (payload[k]) {
          state[k] = Object.assign(state[k], payload[k])
        }
      } else if (payload[k]) {
        state[k] = payload[k]
      }
    })
  },
  // 切换语言时, 清空数组
  switchLangResetBaseData(state) {
    state.cloudDateOption = []
    state.regionOption = []
    state.exhibitionCascaderOption = []
    state.categorySrprovider = []
    state.kkfxDictionary = []
    state.biddingRegion = []

    // 地区组件数据
    state.regionOption = []
    state.domesticRegionOption = []
    state.biddingRegion = []
    state.phoneAreaOption = []
    // 行业数据
    state.exhibitionCascaderOption = []
    state.exhibitionOneOption = []
    state.exhibitionTwoOption = []
    state.newsOption = []
    state.meetingOption = []
    state.moxingOption = []
    state.checkboxMoxingOption = []
    state.companyOption = []
    state.cloudDateOption = []
    state.addByYourselfOption = []
    state.liveOption = []
    state.posterOption = []
    state.productOption = []
    state.biddingOption = []
    // 场景
    state.sceneOption = []
    // 货币类型
    state.capitalUnitOption = []
    // 分类基础数据
    state.categorySrprovider = []
    state.categoryMoxing = []
    state.categoryNews = []
    state.categoryDesigner = []
    state.categoryThirddCompany = []
    state.categoryThirdd = []
    state.checkboxCategorySrprovider = []
    state.checkboxCategoryDesigner = []
    // 字典基础数据
    state.kkfxDictionary = []
    state.mjdxDictionary = []
    state.deliveryDictionary = []
    state.exchangedDictionary = []
    state.biddingDictionary = []
    state.currencyDictionary = []
    state.presaleDictionary = []
    // 过去和未来的五年数据
    state.pastFutureFiveYears = []
  },
  // 设置用户位置信息
  setLocalContent(state, data) {
    state.localContent = data
  },
  setRegionSelect(state, data) {
    state.regionSelect = data
  },
  setExhibitionStatus(state, data) {
    state.exhibitionStatus = data
  },
}
export const actions = {
  // 获取地区组件选择数据
  async getRegionOption({ commit, state }) {
    try {
      if (process.client && !state.regionOption.length) {
        const result = await getRegionOption()
        if (result.success) {
          commit('update', result.data)
        } else {
          notification.error({
            message: '服务端错误',
            description: `地区基础数据加载失败${result.message ? `原因：${result.message}` : ''},请刷新页面`,
          })
        }
      }
    } catch (err) {
      return Promise.reject(err)
    }
  },
  // 获取行业组件数据
  async getIndustryOption({ commit, state }) {
    try {
      if (process.client) {
        if (!state.exhibitionCascaderOption.length) {
          const result = await getIndustryOption()
          if (result.success) {
            commit('update', result.data)
          } else {
            notification.error({
              message: '服务端错误',
              description: `行业基础数据加载失败${result.message ? `原因：${result.message}` : ''},请刷新页面`,
            })
          }
        }
      }
    } catch (err) {
      return Promise.reject(err)
    }
  },
  // 获取分类组件数据
  async getCategoryOption({ commit, state }) {
    try {
      if (process.client && !state.categorySrprovider.length) {
        const result = await getCategoryOption()
        if (result.success) {
          commit('update', result.data)
        } else {
          notification.error({
            message: '服务端错误',
            description: `分类基础数据加载失败${result.message ? `原因：${result.message}` : ''},请刷新页面`,
          })
        }
      }
    } catch (err) {
      return Promise.reject(err)
    }
  },
  // 获取字典组件数据
  async getDictionaryOption({ commit, state }) {
    try {
      if (process.client && !state.kkfxDictionary.length) {
        const result = await getDictionaryOption()
        if (result.success) {
          commit('update', result.data)
        } else {
          notification.error({
            message: '服务端错误',
            description: `字典基础数据加载失败${result.message ? `原因：${result.message}` : ''},请刷新页面`,
          })
        }
      }
    } catch (err) {
      return Promise.reject(err)
    }
  },
  // 获取过去和未来的五年数据
  getPastFutureFiveYears({ commit, state, rootState }) {
    if (!state.pastFutureFiveYears.length) {
      const lang = rootState.locale
      // console.log('getPastFutureFiveYears', lang)
      const pastFutureFiveYears = []
      // 生成月
      const month = []
      for (let i = 0; i < 12; i++) {
        const num = i
        const monthMoment = moment().locale(lang).month(i).format('Mo')
        month.push({
          label: `${monthMoment}`,
          value: num + 1,
        })
      }
      // console.log('month', month)
      // 生成年月
      for (let i = 0; i < 5; i++) {
        const year = moment()
          .locale(lang)
          .add(i - 2, 'Y')
          .format('YYYY')

        pastFutureFiveYears.push({
          label: `${year}`,
          value: year,
          children: month,
        })
      }
      // console.log('pastFutureFiveYears', pastFutureFiveYears)
      commit('update', { pastFutureFiveYears })
    }
    return state.pastFutureFiveYears
  },
  // 获取展览状态
  async getExhibitionStatus({ commit, state }) {
    try {
      if (process.client) {
        if (!state.exhibitionStatus.length) {
          const result = await getExhibitionStatus()
          if (result.code === 0) {
            commit('setExhibitionStatus', result.data)
            // state.exhibitionStatus = { ...result.data }
            // return result.data
            commit('update', { exhibitionStatus: result.data })
          } else {
            notification.error({
              message: '服务端错误',
              description: `展览状态加载失败${result.message ? `原因：${result.message}` : ''},请刷新页面`,
            })
          }
        } else {
          return state.exhibitionStatus
        }
      }
    } catch (err) {
      console.log('err', err)
    }
  },
  // 获取地区组件选择数据
  async getBiddingRegionOption({ commit, state }) {
    try {
      if (process.client) {
        if (!state.biddingRegion.length) {
          const result = await getBiddingRegion()
          if (result.code === 0) {
            commit('update', { biddingRegion: result.data })
            return result.data
          } else {
            notification.error({
              message: '服务端错误',
              description: `地区基础数据加载失败${result.message ? `原因：${result.message}` : ''},请刷新页面`,
            })
          }
        } else {
          return state.biddingRegion
        }
      }
    } catch (err) {
      return Promise.reject(err)
    }
  },
  async getUserIsInChina({ commit, state }) {
    try {
      if (process.client) {
        if (state.isInChina.isChina === null) {
          const result = await getIsInChina()
          if (result.code === 0) {
            commit('update', { isInChina: result.data })
            return result.data
          }
        } else {
          return state.isInChina
        }
      }
    } catch (err) {
      return Promise.reject(err)
    }
  },
}
export const getters = {
  /**
   * 地区组件数据
   * @use 搜索筛选器|
   */
  regionOption(state) {
    return state.regionOption
  },
  /**
   * 展览行业一级分类,二级分页
   * @use 搜索筛选器|
   */
  exhibitionCascaderOption(state) {
    return state.exhibitionCascaderOption
  },
  /**
   * 展厅模型类型数据
   * @use 发布模型|
   */
  showroomTypeOption(state) {
    // console.log('showroomTypeOption', state)
    return state.categoryMoxing
  },
  /**
   * 工程商擅长类型
   * @use 发布模型|
   */
  engineerCategoryOption(state) {
    return state.categoryMoxing
  },
  /**
   * 展厅模型行业分类数据
   * @use 发布模型|
   */
  showroomIndustryOption(state) {
    return state.moxingOption
  },
  /**
   * 开口方向基础数据
   * @use 发布模型|
   */
  kkfxDictionaryOption(state) {
    return state.kkfxDictionary
  },
  // 手机号码的-国际号
  phoneAreaOption(state) {
    return state.phoneAreaOption
  },
  // 用户地址
  localContent(state) {
    return state.localContent
  },
  regionSelect(state) {
    return state.regionSelect
  },

  // /**
  //  * 过去和未来的五年数据
  //  * @use 展览模式|
  //  */
  // pastFutureFiveYears(state) {
  //   return state.pastFutureFiveYears
  // }
}
